<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-tabs>
      <v-tab>Geral</v-tab>            
      <v-tab>Operações</v-tab>

      <v-spacer></v-spacer>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="entry.clientName"
              v-bind="getObject('clientName')"
              label="Cliente"
              autocomplete="off"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <DateField
              :inputData.sync="entry.saleDate"
              v-bind="getObject('saleDate')"
              label="Data da venda"
              :hasTodayButton="true"
              :hasTodayDate="true"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>


        </v-row>
        <v-row>
          

          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="entry.saleLot"
              v-bind="getObject('saleLot')"
              label="Lote de venda"
              autocomplete="off"
              readonly
            />
          </v-col>

          

          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="entry.cropLot"
              v-bind="getObject('cropLot')"
              label="Lote de destinação"
              autocomplete="off"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="entry.originalLot"
              v-bind="getObject('originalLot')"
              label="Lote da semente"
              autocomplete="off"
              readonly
            />
          </v-col>
          
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" class="mt-3">
            <OperationIndex
              :readOnly="readOnly"
              :hasTableTitle="true"
              :entryId="entry.saleLotId"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <template v-slot:expand="{ item, headers }">
        <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
          <OperationIndex
            v-if="true"
            :hasTableTitle="true"
            :hasTopMenu="false"
            :loading="true"
            class="mt-6"
            :readOnly="readOnly"
          />
        </td>
      </template>

       <template v-slot:expandColumn="{ item, isExpanded, expand }">
         <v-btn text color="primary" v-if="!isExpanded">Ver Insumos</v-btn>
         <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Insumos</v-btn>
       </template>

    </v-tabs>
    
  </v-form>
</template>

<script>
// import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import DateField from "@shared_components/date_field.vue";
import OperationIndex from "./operation_index.vue";
// import SaleOrderProductIndex from "@models/sales/sale_orders/sale_order_products/index.vue"

import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      saleTotalPayment: 0,
      productsTotalPrice: 0,
      totalCarriageValueKey: 0,
      pageLoading: false,
    };
  },
  props: {
    oldCropLot: String,
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    // MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    // SaleOrderProductIndex: SaleOrderProductIndex,
    DateField: DateField,
    // PaymentIndex: PaymentIndex,
    // PersonNew: PersonNew,
    BaseUtil: BaseUtil,
    OperationIndex: OperationIndex,
    // PlanningIndex: PlanningIndex,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    console.log(this.entry);
    // this.fiscalDocumentTypeChanged();
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    
  },
  methods: {
    // getOldCropLot: function(entry){
    //   this.oldCropLot = entry.oldPlantLot + '-' + entry.oldCropLot;
    //   return entry.oldPlantLot + '-' + entry.oldCropLot;
    // },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    clearFields: function() {
      this.forceRerender(this);
    },
  }
};
</script>

<style scoped>
  #saleSummary {
    color: gray;
  }
</style>
